import { useTranslation } from 'react-i18next';
import { textColor } from '../../theming';
import NoValue from './NoValue';

const CarConfidence = ({ attempt }) => {
    const { t } = useTranslation('vinExtraction');

    if (!attempt || attempt.confidence === null) return <NoValue label={t('cars.noConfidence')} />;

    return (
        <span style={{ color: attempt.lowConfidence ? textColor.warning : textColor.primary, fontWeight: 500 }}>
            {attempt.confidence.toFixed(2)}
        </span>
    );
};

export default CarConfidence;
